import { GridColumn, GridRow } from 'app/layouts/grid';
import Spinner from 'app/shared/spinners/spinner-25/spinner-25';
import { useMembershipService } from 'hooks/iam/membership';
import { useUserService } from 'hooks/iam/user';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addDataToStore } from 'store/actions/user-data';
import styles from './switch.module.css';
import { Icon } from 'assets/icons';
import cx from 'classnames';
import { useNavigate } from 'react-router-dom';

const OrganizationOption = ({ current, data, onClick = () => {} }) => {
  const is_disabled = data.status !== 'active';
  return (
    <GridColumn>
      <div
        className={cx(styles.itemWrapper, {
          [styles.itemWrapperStyled]: !!current,
          [styles.disabled]: is_disabled
        })}
        onClick={() => !is_disabled && onClick(data)}
      >
        {data.name}
        {is_disabled && <span className={styles.inactiveTag}>- deactivated</span>}
        {current && (
          <span>
            <Icon name="check" width={16} height={16} />
          </span>
        )}
      </div>
    </GridColumn>
  );
};

export const SwitchOrganizationModal = ({ closeModal = () => {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { email, id: user_id, tenant_id } = useSelector((store) => store.user_data);

  const { switchTenant } = useMembershipService();
  const { fetchOrganizations } = useUserService();

  const [is_switching, setIsSwitching] = useState(false);
  const [my_orgs, setMyOrgs] = useState([]);

  useEffect(() => {
    fetchOrganizations({ query_string: '' }, true).then(({ organizations, error }) => {
      if (error) return;

      const orgs_by_id = organizations.reduce((acc, org) => {
        acc[org.tenant_id] = org;
        return acc;
      }, {});

      const active_orgs = [];
      const inactive_orgs = [];
      Object.values(orgs_by_id).forEach((org) => {
        if (org.is_active) {
          active_orgs.push(org);
        } else {
          inactive_orgs.push(org);
        }
      });

      setMyOrgs(() => [...active_orgs, ...inactive_orgs]);
    });

    return () => {
      setIsSwitching(() => false);
    };
  }, []);

  const handleSwitch = async (org_data) => {
    setIsSwitching(true);
    const data = {
      email,
      user_id,
      role_id: 'generic',
      tenant_id: org_data.id
    };
    const payload = await switchTenant({ data });
    if (payload && payload.id) {
      dispatch(addDataToStore({ ...payload, logged_in_time: Date.now() }));
      closeModal();
    }

    setIsSwitching(false);
    navigate('/dashboard');
  };

  return (
    <div className={styles.list}>
      {is_switching ? (
        <div className={styles.switchWrapper}>
          <Spinner />
          <span>Switching Organization</span>
        </div>
      ) : (
        <GridRow num_of_columns={2}>
          {my_orgs.map(({ tenant, is_active }) => (
            <OrganizationOption
              current={tenant.id === tenant_id}
              key={tenant.id}
              data={{ ...tenant, status: is_active ? 'active' : 'inactive' }}
              onClick={handleSwitch}
            />
          ))}
        </GridRow>
      )}
    </div>
  );
};
